import React from 'react'
import './styles.scss'

import Loader from 'react-loader-spinner'

const LoaderSpinner = ({ show }) => (
  <div className="loading-container">
    <Loader
      type="TailSpin"
      color="#1F3060"
      height={80}
      width={80}
      visible={show} />
  </div>
)

export default LoaderSpinner